import { render, staticRenderFns } from "./paxTotalsBase.vue?vue&type=template&id=81c77590&scoped=true&"
import script from "./paxTotalsBase.vue?vue&type=script&lang=js&"
export * from "./paxTotalsBase.vue?vue&type=script&lang=js&"
import style0 from "./paxTotalsBase.vue?vue&type=style&index=0&id=81c77590&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81c77590",
  null
  
)

export default component.exports